<template>
    <div class="bg--layer-light pt--md pb--md mb--md">
        <div class="container">
            <div class="row mb--lg">
                <div class="col-6 offset-3 text--center">
                    <span class="badge badge--lg badge--primary">Level {{ user.level }}</span>
                </div>
                <div class="col-3 text--right">
                    <a href="" class="info-item__status info-item__status--inline">?</a>
                </div>
            </div>

            <p class="text--center opacity--md mb--sm text--sm"><strong>Games</strong></p>

            <div class="progress mb--sm">
                <div class="progress__bar progress__bar--dashed">
                    <span v-for="index in 10" :class="[{'active': index <= seasonData.wins}, {'limit limit--min': index == seasonData.limitMin}, {'limit limit--max': index == seasonData.limitMax}]"></span>
                </div>

                <div class="progress__info">
                    <span class="c--danger">
                        <span v-show="user.level>1">
                            <i class="material-icons">keyboard_arrow_down</i> LVL {{ user.level-1 }}
                        </span>
                    </span>
                    <span class="c--success" v-show="user.level<4">
                        LVL {{ user.level+1 }} <i class="material-icons">keyboard_arrow_up</i>
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="col-8 offset-2">
                    <ul class="counter mb--0">
                        <li>
                            <span class="counter__title">Wins</span>
                            <div class="counter__number">{{ seasonData.wins }}</div>
                        </li>
                        <li>
                            <span class="counter__title">Remaining</span>
                            <div class="counter__number">{{ seasonData.remaining }}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import api from "../../api/users";

export default {
    name: "UserSeasonData",

    data: function () {
        return {
            seasonData: {
                wins: 0,
                remaining: 0,
                limitMin: 0,
                limitMax: 0,
            },
        }
    },

    computed: {
        ...mapGetters('auth', [
            'user',
        ]),
    },

    methods: {
        async loadSeasonData() {
            try {
                let response = await api.seasonData();

                this.seasonData = response.data;
            } catch (error) {

            }
        }
    },

    mounted() {
        this.loadSeasonData();
    },
}
</script>